import { useState, useEffect } from 'react';
import { Button, Modal, ModalHeader, ModalBody } from 'reactstrap';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Autocomplete, TextField } from '@mui/material';
import axiosInstance from "../../helpers/axios";
import { useCurrentUser } from '../../hooks/useCurrentUser';

const ManageProductModal = ({ isOpen, selectedItem, onToggle, onSuccess }) => {
  const decode = useCurrentUser();
  const user = null;
  console.log("Decoded user:", selectedItem);
  const [productStatus, setProductStatus] = useState(null);
  const [instituteList, setInstituteList] = useState(null);
  const [selectedInstitutes, setSelectedInstitutes] = useState([]);
  const [instituteIds, setInstituteIds] = useState([]);
  const [selectedInstituteDetails, setSelectedInstituteDetails] = useState([]);

  useEffect(() => {
    if (selectedItem?.instituteId) {
      const idsToLoad = Array.isArray(selectedItem.instituteId) 
        ? selectedItem.instituteId 
        : [selectedItem.instituteId];
      loadInstituteDetails(idsToLoad);
    }
  }, [selectedItem]);

  const loadInstituteDetails = async (ids) => {
    try {
      const details = [];
      const idArray = [];
      for (const item of ids) {
        const actualId = typeof item === 'string' ? item : item.id;
        idArray.push(actualId);
        console.log("Loading institute with ID:", actualId);
        
        const response = await axiosInstance.get(`/institute/info/id?id=${actualId}`, {
          headers: {
          }
        });
        if (response.data.data) {
          details.push(response.data.data);
        }
      }
      setSelectedInstituteDetails(details);
      setInstituteIds(idArray);
      const transformedDetails = details.map(detail => ({
        label: detail?.name || detail?.brandName || "Unknown",
        ...detail
      }));
      setSelectedInstitutes(transformedDetails);
    } catch (err) {
      console.error("Error loading institute details:", err);
    }
  };
  
  const ProcessingFeeTypeArray = ["", "Flat", "Percentage"];
  const FacilityTypeArray = ["", "Dicounted Interest", "Standard Interest", "Hybrid", "Business To Business"];
  const InterestTypeArray = ["", "Reducing", "Flat"];

  const handleProductStatus = (e) => {
    setProductStatus(e);
  };

  const getInstituteInfo = (text) => {
    const urlGetInstitute = `/institute/info/name?name=${text}`;
    
    if (text.length >= 4) {
      axiosInstance.get(urlGetInstitute, {
        headers: {
        }
      }).then((res) => {
        if (!res.data.data || res.data.data.length === 0) {
          setInstituteList([]);
        } else {
          setInstituteList(res.data.data);
        }
      }).catch((err) => {
        console.error("Error fetching institutes:", err);
        setInstituteList([]);
      });
    } else {
      setInstituteList([]);
    }
  };

  const handleSelectInstitute = async (selectedItem) => {
    if (selectedItem) {
      const itemsWithLabel = selectedItem.map(item => ({
        label: item?.label || item?.name || item?.brandName || "Unknown",
        ...item
      }));
      setSelectedInstitutes(itemsWithLabel);
      const ids = selectedItem.map(item => typeof item === 'string' ? item : item.id);
      setInstituteIds(ids);
      console.log("Selected Institute IDs:", ids);
      
      try {
        const details = [];
        for (const id of ids) {
          const response = await axiosInstance.get(`/institute/info/id?id=${id}`, {
            headers: {
            }
          });
          if (response.data.data) {
            details.push(response.data.data);
          }
        }
        setSelectedInstituteDetails(details);
      } catch (err) {
        console.error("Error loading institute details:", err);
      }
    }
  };

  const handleSubmit = () => {
    const updateProductStatus = `/products/update`;

    const body = {
      instituteId: instituteIds,
      productId: selectedItem.productId,
      status: Number(productStatus !== null ? productStatus : selectedItem.status),
      updatedBy: decode?.display_name
    }
    
    console.log("Submitting update with body:", body);
    axiosInstance.post(updateProductStatus, body, {
      headers: {
      }
    })
    .then((res) => {
      alert("Success");
      setProductStatus(null);
      setSelectedInstitutes([]);
      setInstituteIds([]);
      setSelectedInstituteDetails([]);
      if (onSuccess) {
        onSuccess();
      }
      onToggle();
      window.location.reload();
    })
    .catch((err) => {
      alert('Error', err);
    });
  };

  return (
    <Modal isOpen={isOpen} size="xl">
      <ModalHeader toggle={onToggle}>Manage Product</ModalHeader>
      <ModalBody>
        {selectedItem && (
          <div style={{
            boxShadow: '0px 0px 5px 0px rgb(0,0,0.3,0.6)',
            padding: '7px',
            marginBottom: '8px',
            marginLeft: '5px',
            marginRight: '5px'
          }}>
            <div style={{ display: 'flex', flexDirection: 'column', paddingLeft: '2em', marginBottom: '1.5em', gap: '1em' }}>
              <Autocomplete
                multiple
                sx={{ 
                  "& .MuiPopper-root": { fontFamily: 'Outfit' },
                  width: '500px'
                }}
                size="small"
                options={(instituteList || []).map(item => ({
                  label: item?.brandName || item?.name || "Unknown",
                  ...item
                }))}
                getOptionLabel={(option) => option?.label || option?.name || option?.brandName || "Unknown"}
                value={selectedInstitutes}
                filterSelectedOptions
                onChange={(event, newValue) => handleSelectInstitute(newValue)}
                onInputChange={(event, value) => getInstituteInfo(value)}
                isOptionEqualToValue={(option, value) => option?.id === value?.id}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Institute Name"
                    InputLabelProps={{
                      sx: {
                        fontFamily: 'Outfit',
                        bgcolor: "#fff8f4",
                        fontWeight: 'bold',
                        borderRadius: '5px',
                        fontSize: '16px',
                      }
                    }}
                  />
                )}
              />
            </div>

            <div style={{ display: 'flex', paddingLeft: '2em', gap: '1em', alignItems: 'center' }}>
              <select 
                onChange={(e) => handleProductStatus(e.target.value)} 
                value={productStatus || ''}
                style={{
                  padding: '0.5em',
                  borderRadius: '4px',
                  border: '1px solid #CACCCE',
                  fontFamily: 'Inter'
                }}
              >
                <option value="">Change Status</option>
                <option value={0}>In-Active</option>
                <option value={1}>Active</option>
              </select>
              <Button
                style={{ 
                  height: '2.5em',
                  backgroundColor: '#D32028',
                  borderColor: '#D32028',
                  color: 'white',
                  fontWeight: 'bold'
                }}
                onClick={handleSubmit}
              >
                Submit
              </Button>
            </div>

            <Accordion
              style={{
                marginBottom: '1em',
                marginTop: '10px',
                boxShadow: '0px 0px 2px 2px #F0F0F0',
                margin: '2em'
              }}
              key={selectedItem.productId}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2a-content"
                id="panel2a-header"
              >
                <Typography>
                  <span style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <h5 style={{ color: "#d32028", width: '14em' }}>
                      Product ID: {selectedItem.name}
                    </h5>
                    <h5 style={{ width: '14em' }}>Tenure: {selectedItem.tenure}</h5>
                    <h5 style={{ width: '14em' }}>
                      Status: {selectedItem.status ? "ACTIVE" : "IN-ACTIVE"}
                    </h5>
                  </span>
                </Typography>
              </AccordionSummary>

              <AccordionDetails>
                <Typography>
                  <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                    <div style={{ display: 'block' }}>
                      <p><strong>Advance EMI :</strong> {selectedItem.advanceEmis}</p>
                      <p>
                        <strong>Interest Type :</strong>{' '}
                        {selectedItem.facilityType === 1 || selectedItem.facilityType === 5
                          ? InterestTypeArray[selectedItem.discountedInterestType]
                          : selectedItem.facilityType === 2
                          ? InterestTypeArray[selectedItem.standardInterestType]
                          : selectedItem.facilityType === 3
                          ? `${InterestTypeArray[selectedItem.discountedInterestType]}`
                          : null}
                      </p>
                      <p><strong>Facility Type :</strong> {FacilityTypeArray[selectedItem.facilityType]}</p>
                      <p><strong>Tenure :</strong> {selectedItem.tenure}</p>
                    </div>

                    <div style={{ display: 'block' }}>
                      <p>
                        <strong>Rate :</strong>{' '}
                        {selectedItem.facilityType === 1 || selectedItem.facilityType === 5
                          ? selectedItem.discountedInterestPercentage
                          : selectedItem.facilityType === 2
                          ? selectedItem.standardInterestPercentage
                          : selectedItem.facilityType === 3
                          ? `${selectedItem.discountedInterestPercentage} student share : ${selectedItem.studentShare}`
                          : null}
                      </p>
                      <p>
                        <strong>GST (yes/no) :</strong>{' '}
                        {selectedItem.processingfeeValueGST === 0
                          ? "No"
                          : `Yes ${selectedItem.processingfeeValueGST}`}
                      </p>
                      <p>
                        <strong>Processing Fee :</strong> {selectedItem.processingfeValueIncludingGST}{' '}
                        ({ProcessingFeeTypeArray[selectedItem.processingfeeType]})
                      </p>
                      <p><strong>Advance EMI :</strong> {selectedItem.advanceEmis}</p>
                       {decode?.clientId === '98ffb18a-9fee-43a5-91a3-4b2b9d9ae361' && <p><strong>Other Charges :</strong> {selectedItem.otherCharges}</p>}
                       {decode?.clientId === '98ffb18a-9fee-43a5-91a3-4b2b9d9ae361' && (
                         <>
                           <p>
                             <strong>Document Charges :</strong> {selectedItem.documentChargesValueGst}{' '}
                             ({ProcessingFeeTypeArray[selectedItem.documentChargesType]})
                           </p>
                           <p><strong>Stamp Duty :</strong> {selectedItem.stampDuty || 0}</p>
                         </>
                       )}
                    </div>
                  </div>

                  <div
                    style={{
                      display: 'block',
                      backgroundColor: '#FFF8F4',
                      boxShadow: '0px 0px 2px 2px  #F9D8D6',
                      borderRadius: '10px',
                      padding: '1em',
                      width: '50%',
                      marginLeft: '20%'
                    }}
                  >
                    <div style={{ display: 'block' }}>
                      <ul style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        textDecoration: 'none',
                        listStyle: 'none'
                      }}>
                        <li style={{ width: '10em', color: '#d32028', fontWeight: 'bold' }}>
                          Disburse Month
                        </li>
                        <li style={{ width: '5em' }}>{selectedItem.disbursementMonth1}</li>
                        <li style={{ width: '5em' }}>{selectedItem.disbursementMonth2}</li>
                        <li style={{ width: '5em' }}>{selectedItem.disbursementMonth3}</li>
                        <li style={{ width: '5em' }}>{selectedItem.disbursementMonth4}</li>
                      </ul>

                      <ul style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        listStyle: 'none'
                      }}>
                        <li style={{ width: '10em', color: '#d32028', fontWeight: 'bold' }}>
                          Percentage
                        </li>
                        <li style={{ width: '5em' }}>{selectedItem.disbursementMonth1Percentage}</li>
                        <li style={{ width: '5em' }}>{selectedItem.disbursementMonth2Percentage}</li>
                        <li style={{ width: '5em' }}>{selectedItem.disbursementMonth3Percentage}</li>
                        <li style={{ width: '5em' }}>{selectedItem.disbursementMonth4Percentage}</li>
                      </ul>
                    </div>
                  </div>
                </Typography>
              </AccordionDetails>
            </Accordion>
          </div>
        )}
      </ModalBody>
    </Modal>
  );
};

export default ManageProductModal;
